import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiGithub, FiTwitter, FiLinkedin, FiMail } from 'react-icons/fi';
import NewsletterSignup from './NewsletterSignup';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <img src="/logo.png" alt="Vector Labs" className="footer-logo-img" />
          <div>
            <strong>Vector Labs LLC</strong>
            <p>An applied AI research and engineering lab that builds ambitious products and deploys elite teams to help organizations move faster.</p>
            <NewsletterSignup id="footer-newsletter-email" />
          </div>
        </div>

        <div className="footer-columns">
          <div className="footer-col">
            <h4>Work</h4>
            <Link to="/research">Research Lab</Link>
            <Link to="/products">Fullstack apps</Link>
            <Link to="/security">Security quote</Link>
            <Link to="/#subsidies">Subsidies</Link>
          </div>
          <div className="footer-col">
            <h4>Resources</h4>
            <Link to="/blog">Engineering Log</Link>
            <Link to="/blog">Blog</Link>
            <a href="#github">Open Source</a>
            <Link to="/research">Papers</Link>
          </div>
          <div className="footer-col">
            <h4>Company</h4>
            <Link to="/">About</Link>
            <Link to="/careers">Careers</Link>
            <Link to="/consulting">Contact</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms &amp; Conditions</Link>
          </div>
        </div>

        <div className="footer-cta">
          <h3>Ready to move faster?</h3>
          <p>We deploy small elite teams that ship in weeks, not months.</p>
          <a href="#contact" className="cta-button">
            Get in Touch <FiArrowRight />
          </a>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2026 Vector Labs LLC. All rights reserved. Charlotte, NC.</p>
          <div className="footer-social">
            <a href="#github" aria-label="GitHub"><FiGithub /></a>
            <a href="#twitter" aria-label="Twitter"><FiTwitter /></a>
            <a href="#linkedin" aria-label="LinkedIn"><FiLinkedin /></a>
            <a href="#email" aria-label="Email"><FiMail /></a>
          </div>
        </div>
      </div>
    </footer>
  );
}
